import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Hidden from "@mui/material/Hidden";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Menu from "@mui/icons-material/Menu";
import Button from "components/CustomButtons/Button";
import DashNavbarLinks from "components/Navbars/DashNavbarLinks";
import styles from "assets/jss/default/components/adminNavbarStyle.js";

const useStyles = makeStyles(styles);

export default function DashNavbar({
  sidebarMinimize,
  miniActive,
  handleDrawerToggle,
  children
}) {
  const classes = useStyles();

  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.container}>
        <Hidden mdDown implementation="css">
          <div className={classes.sidebarMinimize}>
            <Button
              aria-label={miniActive ? "Expand sidebar" : "Minimise sidebar"}
              justIcon
              round
              color="white"
              onClick={sidebarMinimize}
            >
              {miniActive ? (
                <ChevronRightIcon className={classes.sidebarMiniIcon} />
              ) : (
                <ChevronLeftIcon className={classes.sidebarMiniIcon} />
              )}
            </Button>
          </div>
        </Hidden>
        <div className={classes.flex}>
          <span className={classes.title}>{children}</span>
        </div>
        <Hidden mdDown implementation="css">
          <DashNavbarLinks />
        </Hidden>
        <Hidden mdUp implementation="css">
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

DashNavbar.propTypes = {
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func,
  children: PropTypes.node
};
